import { makeStyles } from '@material-ui/core';

// Wordmark clássico (decisão de produto v2) — paths extraídos do export
// Figma em wordmark.svg (mesma pasta), com os 2 <rect fill="white"> de
// fundo removidos (artefato do Figma) e mantido só o traçado #DB2328.
// viewBox útil: 0 0 521 80.
const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 27,
  },
});

export const LogoFull = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 521 80"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.7614 7.75375C33.2017 -2.58458 47.8588 -2.58458 52.2991 7.75375L78.5322 68.8324C80.277 72.8947 78.3982 77.6023 74.3359 79.3471C70.2735 81.0919 65.5659 79.2131 63.8212 75.1508L57.9516 61.4846H23.1089L17.2394 75.1508C15.4946 79.2131 10.787 81.0919 6.72464 79.3471C2.66228 77.6023 0.78351 72.8947 2.52828 68.8324L28.7614 7.75375ZM29.9854 45.4741H51.0751L40.5303 20.9225L29.9854 45.4741Z"
        fill="#DB2328"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M88.7847 11.1802C88.7847 5.00554 93.7902 4.76831e-07 99.9649 4.76831e-07H125.141C140.346 4.76831e-07 152.672 12.326 152.672 27.5308C152.672 42.7357 140.346 55.0617 125.141 55.0617H104.756V72.013C104.756 76.4235 101.181 79.9989 96.7705 79.9989C92.3601 79.9989 88.7847 76.4235 88.7847 72.013V11.1802ZM104.756 39.09H125.141C131.525 39.09 136.7 33.9148 136.7 27.5308C136.7 21.1469 131.525 15.9717 125.141 15.9717H104.756V39.09Z"
        fill="#DB2328"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M176.671 39.9995C176.671 53.2541 187.416 63.9991 200.671 63.9991C213.925 63.9991 224.67 53.2541 224.67 39.9995C224.67 26.7448 213.925 15.9998 200.671 15.9998C187.416 15.9998 176.671 26.7448 176.671 39.9995ZM200.671 4.76831e-07C178.58 4.76831e-07 160.671 17.9084 160.671 39.9995C160.671 62.0905 178.58 79.9989 200.671 79.9989C222.762 79.9989 240.67 62.0905 240.67 39.9995C240.67 17.9084 222.762 4.76831e-07 200.671 4.76831e-07Z"
        fill="#DB2328"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M259.876 1.26897e-07C264.297 -6.63678e-08 267.881 3.58423 267.881 8.00561V71.9933C267.881 76.4147 264.297 79.9989 259.876 79.9989C255.454 79.9989 251.87 76.4147 251.87 71.9933V8.00561C251.87 3.58423 255.454 3.20161e-07 259.876 1.26897e-07Z"
        fill="#DB2328"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M305.967 7.75375C310.407 -2.58458 325.064 -2.58458 329.505 7.75375L355.738 68.8324C357.483 72.8947 355.604 77.6023 351.541 79.3471C347.479 81.0919 342.771 79.2131 341.027 75.1508L335.157 61.4846H300.315L294.445 75.1508C292.7 79.2131 287.993 81.0919 283.93 79.3471C279.868 77.6023 277.989 72.8947 279.734 68.8324L305.967 7.75375ZM307.191 45.4741H328.281L317.736 20.9225L307.191 45.4741Z"
        fill="#DB2328"
      />
      <path
        d="M364.387 71.999C364.387 67.5808 367.969 63.9991 372.387 63.9991C376.805 63.9991 380.387 67.5808 380.387 71.999C380.387 76.4172 376.805 79.9989 372.387 79.9989C367.969 79.9989 364.387 76.4172 364.387 71.999Z"
        fill="#DB2328"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M431.802 31.262C433.778 25.4561 432.724 20.9534 428.877 20.1977C423.787 19.1979 421.068 23.8695 419.275 28.3001C416.153 36.0173 410.258 50.4459 391.044 65.209C388.467 67.1884 387.292 70.4608 389.472 73.217C391.586 75.8897 394.886 75.8093 397.864 73.9839C401.102 71.9992 405.747 67.7621 405.747 67.7621C406.561 75.922 417.991 78.8745 422.973 79.6324C433.044 81.1647 445.131 77.9023 457.628 69.9226C477.789 88.7329 499.787 71.9322 506.754 59.7415C508.648 56.4278 509.642 50.1417 504.93 49.548C501.049 49.059 499.335 51.6748 496.584 55.0854C489.57 63.7802 477.926 71.0582 470.037 62.5998C478.518 57.9057 494.038 47.0832 494.038 34.014C494.038 27.7838 490.322 22.1728 484.411 20.1977C477.436 17.8682 470.291 20.1409 464.835 24.6955C455.743 32.2824 452.49 47.2922 454.384 59.7415C450.737 62.6029 444.135 65.209 444.135 65.209C450.309 49.7725 428.725 40.3017 431.802 31.262ZM411.918 62.6029C417.058 58.0498 420.15 54.4392 424.276 46.0145C425.494 49.4731 431.269 51.7353 433.561 58.0498C435.968 64.6829 432.321 69.7447 423.783 69.0058C418.672 68.5634 416.312 62.6029 411.918 62.6029ZM466.267 52.4911C469.489 50.7801 477.352 45.2209 480.673 38.9673C483.691 33.2837 480.559 28.6601 475.783 31.0502C471.006 33.4402 465.713 43.4006 466.267 52.4911Z"
        fill="#DB2328"
      />
    </svg>
  );
};
